import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/* ---------------------------------------------------------------------------
   Koshnika sticky bar (15 Sep 2026)

   The bar is rendered complete by sections/koshnika-product-information.liquid
   and is always visible, so this file no longer watches the scroll position or
   builds buttons. It does two things:
   • Add to cart presses the real product-form button, so the cart drawer, the
     fly-to-cart animation and error handling stay Horizon's own.
   • When the shopper picks another variant, the price row, the Add to cart
     state and Buy now are refreshed from the section HTML Horizon already
     fetched.
   Buy now itself is a plain form submit (blocks/buy-buttons.liquid) and does
   not depend on this module loading.
--------------------------------------------------------------------------- */
class StickyAddToCartComponent extends Component {
  requiredRefs = ['stickyBar', 'addToCartButton', 'quantityDisplay', 'quantityNumber'];
  #abortController = null;
  #targetAddToCartButton = null;

  connectedCallback() {
    super.connectedCallback();
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    this.#targetAddToCartButton = this.#getProductForm()?.querySelector('[ref="addToCartButton"]') || null;
    const section = this.closest('.shopify-section');
    section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
    document.addEventListener(ThemeEvents.cartUpdate, this.#resetPuppet, { signal });
    document.addEventListener(ThemeEvents.cartError, this.#resetPuppet, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
  }

  handleAddToCartClick = () => {
    if (!this.#targetAddToCartButton || !this.#targetAddToCartButton.isConnected) {
      this.#targetAddToCartButton = this.#getProductForm()?.querySelector('[ref="addToCartButton"]') || null;
    }
    if (!this.#targetAddToCartButton || this.#targetAddToCartButton.disabled) return;
    this.#targetAddToCartButton.dataset.puppet = 'true';
    this.#targetAddToCartButton.click();
    this.refs.addToCartButton.dataset.added = 'true';
  };

  #onVariantUpdate = (event) => {
    if (event.detail.data.productId !== this.dataset.productId) return;
    const fresh = event.detail.data.html.querySelector('sticky-add-to-cart');
    if (!fresh) return;

    this.dataset.variantAvailable = fresh.dataset.variantAvailable;
    this.dataset.currentVariantId = fresh.dataset.currentVariantId;

    const freshButton = fresh.querySelector('[ref="addToCartButton"]');
    if (freshButton) {
      this.refs.addToCartButton.disabled = freshButton.disabled;
      this.refs.addToCartButton.dataset.added = 'false';
      const label = this.refs.addToCartButton.querySelector('.add-to-cart-text__content > span');
      const freshLabel = freshButton.querySelector('.add-to-cart-text__content > span');
      if (label && freshLabel) label.textContent = freshLabel.textContent;
    }

    const row = this.querySelector('[data-kr-stk-row]');
    const freshRow = fresh.querySelector('[data-kr-stk-row]');
    if (row && freshRow) row.innerHTML = freshRow.innerHTML;

    const buy = this.querySelector('[data-kr-buy-now]');
    const freshBuy = fresh.querySelector('[data-kr-buy-now]');
    if (buy && freshBuy) buy.hidden = freshBuy.hidden;

    this.#targetAddToCartButton = this.#getProductForm()?.querySelector('[ref="addToCartButton"]') || null;
  };

  #resetPuppet = () => {
    if (this.#targetAddToCartButton) this.#targetAddToCartButton.dataset.puppet = 'false';
  };

  #getProductForm() {
    const id = this.dataset.productId;
    const section = this.closest('.shopify-section');
    if (!id || !section) return null;
    return section.querySelector(`product-form-component[data-product-id="${id}"]`);
  }
}

if (!customElements.get('sticky-add-to-cart')) customElements.define('sticky-add-to-cart', StickyAddToCartComponent);

(function () {
  function fix() {
    document.querySelectorAll('.kpin input[placeholder]').forEach(function (el) { el.placeholder = 'Enter your PIN code'; });
    document.querySelectorAll('.kosh-feature-text').forEach(function (el) { if (el.textContent.replace(/\s+/g, ' ').trim() === 'Easy Returns') el.innerHTML = '48-Hour<br>Eligible Returns'; });
    document.querySelectorAll('.kw-card h4').forEach(function (el) { if (el.textContent.trim() === 'Easy Returns') el.textContent = '48-Hour Eligible Returns'; });
  }

  /* The WhatsApp launcher comes from an app and arrives late. Tag it so the
     bar can lift it clear. Bounded: boot, load, and once more — no polling. */
  function tagWhatsApp() {
    var links = document.querySelectorAll('a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"], a[href^="whatsapp:"]');
    var found = false;
    links.forEach(function (link) {
      var node = link;
      for (var i = 0; i < 5 && node && node !== document.body; i++) {
        if (window.getComputedStyle(node).position === 'fixed') {
          node.classList.add('k-wa-float');
          found = true;
          return;
        }
        node = node.parentElement;
      }
    });
    return found;
  }

  function boot() {
    fix();
    if (document.querySelector('sticky-add-to-cart')) document.body.classList.add('k-sticky-open');
    if (!tagWhatsApp()) {
      window.addEventListener('load', function () {
        if (!tagWhatsApp()) setTimeout(tagWhatsApp, 2000);
      }, { once: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
